import { useCallback } from "react";

import { FileInfo } from "../chat-types";
import { ChatFileDownloadStatus, ChatFileUploadStatus } from "@zoom/videosdk";
import classNames from "classnames";
import ChatImageMessageItem from "./chat-image-message-item";
import "./chat-file-message-item.scss";
import {
  // isExcelFile,
  isImageFile,
  // isPPTFile,
  // isPdfFile,
  // isWordFile,
  // isZipFile,
} from "../chat-utils";
import CloseIcon from "@mui/icons-material/Close";
// import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { Button, LinearProgress } from "@mui/material";
interface ChatFileMessageItem {
  className: string;
  file: FileInfo;
  id?: string;
  resendFile: (retryToken: string, fileUuid: string) => void;
  downloadFile: (id: string, blob?: boolean) => void;
}

const getFileIcon = (_name: string) => {
  return <InsertDriveFileIcon />;
  // if (isImageFile(name)) {
  //   return <FileImageOutlined />;
  // } else if (isExcelFile(name)) {
  //   return <FileExcelOutlined />;
  // } else if (isWordFile(name)) {
  //   return <FileWordOutlined />;
  // } else if (isPPTFile(name)) {
  //   return <FilePptOutlined />;
  // } else if (isPdfFile(name)) {
  //   return <FilePdfOutlined />;
  // } else if (isZipFile(name)) {
  //   return <FileZipOutlined />;
  // } else {
  //   return <FileOutlined />;
  // }
};
const getFileStatus = (file: FileInfo, id?: string) => {
  if (!id && file.upload) {
    const {
      upload: { status },
    } = file;
    if (
      [ChatFileUploadStatus.InProgress, ChatFileUploadStatus.Init].includes(
        status
      )
    ) {
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="9"
            fill="#0E72ED"
            stroke="white"
            stroke-width="2"
          />
          <path
            d="M10.0005 14.5C9.724 14.5 9.50032 14.2763 9.50032 13.9998C9.50032 13.7243 9.724 13.4997 10.0005 13.4997C11.933 13.4997 13.4997 11.933 13.4997 10.0005C13.4997 8.06704 11.933 6.50032 10.0005 6.50032C8.06704 6.50032 6.50032 8.06704 6.50032 10.0005C6.50032 10.276 6.27568 10.4997 6.00016 10.4997C5.72368 10.4997 5.5 10.276 5.5 10.0005C5.5 7.51504 7.51504 5.5 10.0005 5.5C12.485 5.5 14.5 7.51504 14.5 10.0005C14.5 12.485 12.485 14.5 10.0005 14.5Z"
            fill="white"
          />
        </svg>

        // <IconFont
        //   type="icon-pendding-circle"
        //   style={{ animation: "loading 1s linear infinite" }}
        // />
      );
    } else if (
      status === ChatFileUploadStatus.Complete ||
      status === ChatFileUploadStatus.Success
    ) {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.00033 -0.000152588C3.58214 -0.000152588 0.000488281 3.5815 0.000488281 7.99968C0.000488281 12.4179 3.58214 15.9995 8.00033 15.9995C12.4185 15.9995 16.0002 12.4179 16.0002 7.99968C16.0002 3.5815 12.4185 -0.000152588 8.00033 -0.000152588ZM11.3535 6.35312C11.5487 6.15785 11.5487 5.84127 11.3535 5.64601C11.1582 5.45075 10.8416 5.45075 10.6464 5.64601L6.99999 9.29237L5.35358 7.64597C5.15832 7.45071 4.84174 7.45071 4.64648 7.64597C4.45121 7.84123 4.45121 8.15781 4.64648 8.35308L6.64643 10.353C6.8417 10.5483 7.15828 10.5483 7.35354 10.353L11.3535 6.35312Z"
              fill="#00A832"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

      // <IconFont type="icon-correct" />;
    } else if (
      status === ChatFileUploadStatus.Fail ||
      status === ChatFileUploadStatus.Cancel
    ) {
      return (
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5ZM14.5 17C14.5 17.8284 15.1716 18.5 16 18.5C16.8284 18.5 17.5 17.8284 17.5 17V10C17.5 9.17163 16.8284 8.5 16 8.5C15.1716 8.5 14.5 9.17163 14.5 10V17ZM14.5 22.5C14.5 23.3284 15.1716 24 16 24C16.8284 24 17.5 23.3284 17.5 22.5C17.5 21.6716 16.8284 21 16 21C15.1716 21 14.5 21.6716 14.5 22.5Z"
            fill="#DE2828"
          />
        </svg>
      );
      // return <IconFont type="icon-warning-circle" />;
    }
  }
  if (id && file.upload?.status === ChatFileUploadStatus.Complete) {
    return (
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.00033 -0.000152588C3.58214 -0.000152588 0.000488281 3.5815 0.000488281 7.99968C0.000488281 12.4179 3.58214 15.9995 8.00033 15.9995C12.4185 15.9995 16.0002 12.4179 16.0002 7.99968C16.0002 3.5815 12.4185 -0.000152588 8.00033 -0.000152588ZM11.3535 6.35312C11.5487 6.15785 11.5487 5.84127 11.3535 5.64601C11.1582 5.45075 10.8416 5.45075 10.6464 5.64601L6.99999 9.29237L5.35358 7.64597C5.15832 7.45071 4.84174 7.45071 4.64648 7.64597C4.45121 7.84123 4.45121 8.15781 4.64648 8.35308L6.64643 10.353C6.8417 10.5483 7.15828 10.5483 7.35354 10.353L11.3535 6.35312Z"
            fill="#00A832"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );

    // <IconFont type="icon-correct" />;
  }
  if (file.download) {
    const {
      download: { status },
    } = file;
    if (status === ChatFileDownloadStatus.InProgress) {
      return (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="10"
            cy="10"
            r="9"
            fill="#0E72ED"
            stroke="white"
            stroke-width="2"
          />
          <path
            d="M10.0005 14.5C9.724 14.5 9.50032 14.2763 9.50032 13.9998C9.50032 13.7243 9.724 13.4997 10.0005 13.4997C11.933 13.4997 13.4997 11.933 13.4997 10.0005C13.4997 8.06704 11.933 6.50032 10.0005 6.50032C8.06704 6.50032 6.50032 8.06704 6.50032 10.0005C6.50032 10.276 6.27568 10.4997 6.00016 10.4997C5.72368 10.4997 5.5 10.276 5.5 10.0005C5.5 7.51504 7.51504 5.5 10.0005 5.5C12.485 5.5 14.5 7.51504 14.5 10.0005C14.5 12.485 12.485 14.5 10.0005 14.5Z"
            fill="white"
          />
        </svg>

        // <IconFont
        //   type="icon-pendding-circle"
        //   style={{ animation: "loading 1s linear infinite" }}
        // />
      );
    } else if (status === ChatFileDownloadStatus.Success) {
      return (
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8.00033 -0.000152588C3.58214 -0.000152588 0.000488281 3.5815 0.000488281 7.99968C0.000488281 12.4179 3.58214 15.9995 8.00033 15.9995C12.4185 15.9995 16.0002 12.4179 16.0002 7.99968C16.0002 3.5815 12.4185 -0.000152588 8.00033 -0.000152588ZM11.3535 6.35312C11.5487 6.15785 11.5487 5.84127 11.3535 5.64601C11.1582 5.45075 10.8416 5.45075 10.6464 5.64601L6.99999 9.29237L5.35358 7.64597C5.15832 7.45071 4.84174 7.45071 4.64648 7.64597C4.45121 7.84123 4.45121 8.15781 4.64648 8.35308L6.64643 10.353C6.8417 10.5483 7.15828 10.5483 7.35354 10.353L11.3535 6.35312Z"
              fill="#00A832"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      );

      // <IconFont type="icon-correct" />;
    } else if (
      status === ChatFileDownloadStatus.Cancel ||
      status === ChatFileDownloadStatus.Fail
    ) {
      return (
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 32.5C24.8366 32.5 32 25.3366 32 16.5C32 7.66344 24.8366 0.5 16 0.5C7.16344 0.5 0 7.66344 0 16.5C0 25.3366 7.16344 32.5 16 32.5ZM14.5 17C14.5 17.8284 15.1716 18.5 16 18.5C16.8284 18.5 17.5 17.8284 17.5 17V10C17.5 9.17163 16.8284 8.5 16 8.5C15.1716 8.5 14.5 9.17163 14.5 10V17ZM14.5 22.5C14.5 23.3284 15.1716 24 16 24C16.8284 24 17.5 23.3284 17.5 22.5C17.5 21.6716 16.8284 21 16 21C15.1716 21 14.5 21.6716 14.5 22.5Z"
            fill="#DE2828"
          />
        </svg>
      );
      // return <IconFont type="icon-warning-circle" />;
    }
  }
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="10"
        cy="10"
        r="9"
        fill="#0E72ED"
        stroke="white"
        stroke-width="2"
      />
      <path
        d="M9.5 12.2929V6.5C9.5 6.22388 9.72388 6 10 6C10.2761 6 10.5 6.22388 10.5 6.5V12.2929L12.6465 10.1464C12.8418 9.95117 13.1582 9.95117 13.3535 10.1464C13.5488 10.3417 13.5488 10.6583 13.3535 10.8536L10.3535 13.8536C10.1582 14.0488 9.8418 14.0488 9.64648 13.8536L6.64648 10.8536C6.45117 10.6583 6.45117 10.3417 6.64648 10.1464C6.8418 9.95117 7.1582 9.95117 7.35352 10.1464L9.5 12.2929Z"
        fill="white"
      />
    </svg>
  );

  // <IconFont type="icon-download" />;
};
const getFileSize = (size: number) => {
  if (size < 1024) {
    return `${size} bytes`;
  }
  if (size < 1024 * 1024) {
    return `${(size / 1024).toFixed(1)} KB`;
  }
  return `${(size / 1024 / 1024).toFixed(1)} MB`;
};

const getFileTip = (file: FileInfo, id?: string) => {
  if (file.upload) {
    const {
      upload: { status },
    } = file;
    if (!id) {
      if (status === ChatFileUploadStatus.Fail) {
        return "- Click to resend";
      } else if (status === ChatFileUploadStatus.Cancel) {
        return "- Canceled, click to resend";
      }
    } else if (id && status === ChatFileUploadStatus.Complete) {
      return "- Click to download";
    }
  } else if (file.download) {
    const {
      download: { status },
    } = file;
    if (status !== ChatFileDownloadStatus.InProgress) {
      return "- Click to download";
    }
  }
};

const getFileInProgress = (file: FileInfo, id?: string) => {
  let isInProgress = false;
  let progress = 0;
  if (
    !id &&
    file.upload &&
    [ChatFileUploadStatus.InProgress, ChatFileUploadStatus.Init].includes(
      file.upload?.status
    )
  ) {
    isInProgress = true;
    progress = file.upload.progress;
  } else if (file.download?.status === ChatFileDownloadStatus.InProgress) {
    isInProgress = true;
    progress = file.download.progress;
  }
  return [isInProgress, progress];
};

const ChatFileMessageItem = (props: ChatFileMessageItem) => {
  const { file, id, className, resendFile, downloadFile } = props;
  const { name, size } = file;
  const [isInProgress, progress] = getFileInProgress(file, id);
  const onCancelButtonClick = useCallback(
    (event: any) => {
      event.stopPropagation();
      if (!id && file.upload?.status === ChatFileUploadStatus.InProgress) {
        const {
          upload: { cancelFunc },
        } = file;
        cancelFunc();
      } else if (file.download?.status === ChatFileDownloadStatus.InProgress) {
        const {
          download: { cancelFunc },
        } = file;
        cancelFunc();
      }
    },
    [file, id]
  );

  const onFileItemClick = useCallback(() => {
    if (!isInProgress) {
      if (
        !id &&
        (file.upload?.status === ChatFileUploadStatus.Fail ||
          file.upload?.status === ChatFileUploadStatus.Cancel)
      ) {
        const {
          uuid,
          upload: { retryToken },
        } = file;
        if (retryToken && uuid) {
          resendFile(retryToken, uuid);
        }
      } else if (id) {
        downloadFile(id);
      }
    }
  }, [isInProgress, id, file, resendFile, downloadFile]);

  return (
    <div className={classNames("chat-file-message-wrap", className)}>
      {isImageFile(name) ? (
        <ChatImageMessageItem
          file={file}
          id={id}
          resendFile={resendFile}
          downloadFile={downloadFile}
        />
      ) : (
        <div className="chat-file-message-item" onClick={onFileItemClick}>
          <div className="chat-file-preview">
            <div className="chat-file-icon">{getFileIcon(name)}</div>
            <div className="chat-file-status">{getFileStatus(file, id)}</div>
          </div>
          <div className="chat-file-desc">
            <h4 className="chat-file-name">{name}</h4>
            <div className="chat-file-subline">
              <span className="chat-file-size">{getFileSize(size)}</span>
              {isInProgress ? (
                <>
                  <LinearProgress
                    variant="determinate"
                    value={progress as number}
                  />
                  <Button
                    endIcon={<CloseIcon />}
                    size="small"
                    onClick={onCancelButtonClick}
                  />
                </>
              ) : (
                <div className="chat-file-action-tip">
                  {getFileTip(file, id)}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatFileMessageItem;
